export default __webpack_public_path__ + "88ea50f0770220a773e52cea9eae005f.svg";